var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductDescriptiongeneratorErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 4,
    fill: "#B3B3B3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35462_392539)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 33.6,
    transform: "translate(7.69922 7.19922)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4082 14.9361C10.4082 14.4391 10.8075 14.0361 11.3 14.0361H31.1164C31.6089 14.0361 32.0082 14.4391 32.0082 14.9361C32.0082 15.4332 31.6089 15.8361 31.1164 15.8361H11.3C10.8075 15.8361 10.4082 15.4332 10.4082 14.9361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4082 10.1803C10.4082 9.68322 10.8205 9.28027 11.329 9.28027H35.8827C36.3913 9.28027 36.8035 9.68322 36.8035 10.1803C36.8035 10.6773 36.3913 11.0803 35.8827 11.0803H11.329C10.8205 11.0803 10.4082 10.6773 10.4082 10.1803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4082 19.691C10.4082 19.194 10.7885 18.791 11.2577 18.791H26.3587C26.8279 18.791 27.2082 19.194 27.2082 19.691C27.2082 20.1881 26.8279 20.591 26.3587 20.591H11.2577C10.7885 20.591 10.4082 20.1881 10.4082 19.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9885 17.6199C34.4359 17.8455 34.6785 18.3413 34.5821 18.8331L33.4344 24.6889L37.8705 26.3864C38.2161 26.5186 38.4738 26.8132 38.559 27.1732C38.6441 27.5333 38.5456 27.9121 38.2959 28.1851L28.9953 38.3534C28.6571 38.7232 28.1142 38.8227 27.6669 38.597C27.2195 38.3713 26.9769 37.8755 27.0733 37.3838L28.221 31.528L23.7849 29.8305C23.4393 29.6983 23.1816 29.4037 23.0964 29.0436C23.0113 28.6836 23.1098 28.3048 23.3595 28.0318L32.6601 17.8635C32.9983 17.4937 33.5412 17.3942 33.9885 17.6199Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35462_392539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 33.6,
    fill: "white",
    transform: "translate(7.69922 7.19922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDescriptiongeneratorErrorIcon);
export default __webpack_public_path__ + "static/media/product-description generator-error-icon.aacf1ee3cf74ebd7e87a0ae7f685567c.svg";
export { ForwardRef as ReactComponent };